import { render, staticRenderFns } from "./DualPriceDisplay.vue?vue&type=template&id=3d6681e7&scoped=true&"
import script from "./DualPriceDisplay.vue?vue&type=script&lang=ts&"
export * from "./DualPriceDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./DualPriceDisplay.vue?vue&type=style&index=0&id=3d6681e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6681e7",
  null
  
)

export default component.exports